import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home } from "lucide-react";

export default function AppLayout({ children, narrow = true, showAdminLink = false }) {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="min-h-screen bg-[#F9FAFB] text-[#111827]">
      <header className="rrdc-gradient-band text-white">
        <div className={`mx-auto ${narrow ? "max-w-lg" : "max-w-6xl"} px-4 py-4 flex items-center justify-between`}>
          <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
            <img
              src="/rrdc-logo.png"
              alt="Rolling River Day Camp"
              className="h-11 w-11 rounded-full bg-white p-0.5 shadow-sm"
            />
            <div className="leading-tight">
              <div className="text-xs uppercase tracking-widest opacity-80">Rolling River Day Camp</div>
              <div className="rrdc-heading text-lg font-bold">Trip Sign Ups</div>
            </div>
          </Link>
          {showAdminLink ? (
            <Link
              to="/admin"
              className="text-xs uppercase tracking-widest opacity-90 hover:opacity-100"
              data-testid="header-admin-link"
            >
              Admin
            </Link>
          ) : null}
        </div>
      </header>

      {!isHome ? (
        <div className={`mx-auto ${narrow ? "max-w-lg" : "max-w-6xl"} px-4 pt-4`}>
          <Link
            to="/"
            data-testid="back-to-home"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#2F50A1] hover:text-[#254081] active:scale-95 transition-transform"
          >
            <Home size={16} />
            Back to home
          </Link>
        </div>
      ) : null}

      <main className={`mx-auto ${narrow ? "max-w-lg" : "max-w-6xl"} px-4 py-6`}>{children}</main>
      <footer className={`mx-auto ${narrow ? "max-w-lg" : "max-w-6xl"} px-4 py-8 text-center text-xs text-[#6B7280]`}>
        Rolling River Day Camp
      </footer>
    </div>
  );
}
